
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabservicesname() {



  const cardData =
  {
    keyword: 'Cabs Services Near Me',
    heading: 'AB Ghule Cabs:Cabs Services Near Me',
    headingDescription: 'AB Ghule Cabs offers fast, reliable, and affordable cab services right at your doorstep. Whether you are in need of a quick ride for shopping, heading to work, or planning a trip, we provide a seamless experience with our fleet of well-maintained vehicles and experienced drivers. With our commitment to timely service and customer satisfaction, you can count on us for all your local transportation needs.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Cabs Services Near Me',

    topPlaces: [
        {
          title: "Convenient Booking Process",
          description: "Our booking system is simple and convenient. You can book a cab online or via phone, ensuring that you always have a ride when you need it."
        },
        {
          title: "Affordable Prices",
          description: "We offer competitive and transparent pricing with no hidden charges. Whether it's a short or long ride, you pay the price quoted at the time of booking."
        },
        {
          title: "Prompt and Reliable Service",
          description: "We pride ourselves on providing quick and dependable cab services. Our drivers are punctual and well-versed in local routes, ensuring timely pickups and drop-offs."
        },
        {
          title: "Comfortable Ride",
          description: "Travel in comfort with a wide range of well-maintained vehicles. Choose from sedans, SUVs, and more to enjoy a smooth ride to your destination."
        },
        {
          title: "24/7 Availability",
          description: "No matter the time of day or night, AB Ghule Cabs is available around the clock to ensure you have reliable transportation whenever you need it."
        },
        {
          title: "Experienced Drivers",
          description: "Our professional drivers know the best routes in the city, ensuring a hassle-free journey. They're also trained to assist with your luggage and offer a courteous experience."
        },
        {
          title: "Clean and Safe Vehicles",
          description: "Our vehicles are regularly cleaned and sanitized to provide a safe and hygienic ride, especially important in today's times."
        },
        {
          title: "No Surge Pricing",
          description: "We don’t believe in surge pricing. The fare you see at the time of booking is the fare you pay, with no hidden surprises."
        },
        {
          title: "Easy Payments",
          description: "Enjoy a seamless payment experience with multiple options available, including cash and card payments."
        },
        {
          title: "Safe and Secure Rides",
          description: "We prioritize your safety. All our drivers follow traffic rules and ensure you travel securely from start to finish."
        }
      ],


      services: [
        {
          "name": "Taxi Near Me in Pimpri Chinchwad",
          description: "Looking for a taxi service near you in Pimpri Chinchwad? AB Ghule Cabs offers dependable and affordable taxi services for local travel and intercity rides. Our fleet of well-maintained vehicles ensures a comfortable journey."
        },
        {
          "name": "Taxi Booking Near Me in Pune",
          description: "Book a taxi quickly with AB Ghule Cabs in Pune. We offer reliable online booking services for local and long-distance trips. Enjoy a smooth ride to your destination with our experienced drivers."
        },
        {
          "name": "Cabs Services Near Me in Pune",
          description: "Whether you're in Pune for business or leisure, AB Ghule Cabs offers quick and efficient cab services near you. Book a ride for local or airport transfers, and our professional drivers will ensure a smooth journey."
        },
        {
          "name": "Taxi Near Me in Pune",
          description: "AB Ghule Cabs is your go-to solution for reliable taxi services in Pune. Whether you're traveling from your home, office, or any local location, we guarantee on-time arrivals and comfortable rides."
        },
        {
          "name": "Local Taxi Service Near Me in Pune",
          description: "For local taxi services in Pune, AB Ghule Cabs is always available. Book a ride for your daily commute, shopping trips, or local business meetings with just a few clicks on our online platform."
        },
        {
          "name": "Cab Company Near Me in Pune",
          description: "Looking for a dependable cab company near you in Pune? AB Ghule Cabs provides premium services with a range of vehicles for your travel needs, including economy, luxury, and SUV options."
        },
        {
          "name": "Taxi Cab Near Me in Viman Nagar",
          description: "AB Ghule Cabs offers reliable taxi cab services in Viman Nagar. Whether you're heading to the airport, a meeting, or a family outing, book a cab for a hassle-free and comfortable journey."
        },
        {
          "name": "Taxi Company Near Me in Kharadi",
          description: "AB Ghule Cabs is the best taxi company in Kharadi, Pune. We provide affordable and reliable taxi services for all your transportation needs. Book a ride today for punctual and comfortable travel."
        },
        {
          "name": "Call Taxi Near Me in Kaylani Nagar",
          description: "Need a call taxi near Kaylani Nagar? AB Ghule Cabs offers 24/7 call taxi services in your area. Whether it's a quick ride or a long-distance journey, our experienced drivers ensure timely and safe travel."
        },
        {
          "name": "Cheapest Taxi Service Near Me in Koregaon Park",
          description: "If you're looking for the most affordable taxi services in Koregaon Park, AB Ghule Cabs offers the cheapest rates without compromising on service quality. Book your ride today for a comfortable and budget-friendly journey."
        },
        {
          "name": "Taxi Booking Near Me in Hadapsar",
          description: "Book your taxi easily with AB Ghule Cabs for pick-up or drop-off in Hadapsar. We offer efficient and affordable taxi booking services, ensuring you travel safely and comfortably."
        },
        {
          "name": "24-Hour Taxi Service Near Me",
          description: "AB Ghule Cabs provides round-the-clock taxi services. No matter the time of day or night, we are available 24/7 for all your taxi needs. Whether it’s a late-night airport transfer or early morning commute, we have you covered."
        },
        {
          "name": "Local Cab Company in Lohegaon Airport",
          description: "For local cab services to and from Lohegaon Airport, choose AB Ghule Cabs. Our reliable taxi services ensure timely arrivals and departures, making your airport transfers smooth and stress-free."
        },
        {
          "name": "Best Taxi Service Near Me",
          description: "Looking for the best taxi service near you? AB Ghule Cabs is a top-rated taxi provider in Pune, known for its punctuality, professionalism, and wide variety of vehicles to choose from."
        },
        {
          "name": "Book a Taxi Online Near Me",
          description: "AB Ghule Cabs makes booking a taxi online quick and easy. Choose from our fleet of vehicles, make your booking in minutes, and enjoy reliable, on-time services at affordable rates."
        },
        {
          "name": "Local Cab Service Near Me in Chandan Nagar",
          description: "AB Ghule Cabs offers efficient and affordable local cab services in Chandan Nagar. Whether it's a quick errand, a business trip, or a family outing, we ensure comfortable and timely rides."
        },
        {
          "name": "Nearest Cab Service in Kothrud",
          description: "AB Ghule Cabs is the nearest taxi service provider in Kothrud. Book your ride with ease and travel comfortably with our fleet of well-maintained vehicles and experienced drivers."
        },
        {
          "name": "Cabs Services Near Me Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Shirdi Cab. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData: [
        ["Near me taxi in Pimpri Chinchwad", "-Cabs services near me in Pune"],
        ["Taxi near me in Pune", "-Taxi service near me in Pune"],
        ["Cabs near me in Pune", "-Cab company near me in Pune"],
        ["Taxi cab near me in Viman Nagar", "-Taxi company near me in Kharadi"],
        ["Call taxi near me Kaylani Nagar", "-Cheapest taxi service near me Koregaon Park"],
        ["Local taxi service near me", "-Taxi cab service near me"],
        ["Taxi booking near me Hadapsar", "-24 hour taxi service near me"],
        ["Local cab company in Lohegaon Airport", "-Best Taxi Service near me"],
        ["Book a Taxi online near me", "-Local cab service near me Chandan Nagar"],
        ["Nearest cab service Kothrud", ""]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Timely Service",
          WhyChoosedescription: "At AB Ghule Cabs, we offer reliable and on-time cab services near you, ensuring that you never have to wait long for a ride. Whether it's an urgent need or a pre-planned trip, we are always punctual."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "Our cab services are available round the clock. Whether it's early morning, late at night, or on weekends, you can count on us for timely transportation, anytime, anywhere."
        },
        {
          WhyChooseheading: "Wide Range of Vehicles",
          WhyChoosedescription: "We offer a wide variety of vehicles to choose from, including sedans, SUVs, and luxury cars. Whether you're traveling alone or with a group, we have the right vehicle to suit your needs."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "All our drivers are experienced, licensed, and trained to offer you a safe, comfortable, and pleasant journey. They are well-versed with local routes, ensuring you reach your destination efficiently."
        },
        {
          WhyChooseheading: "Affordable and Transparent Pricing",
          WhyChoosedescription: "AB Ghule Cabs offers competitive pricing with no hidden charges. Our pricing is transparent, so you will know the fare upfront without any surprises."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "We take great pride in keeping our fleet of vehicles in top condition. Each vehicle is regularly cleaned and maintained to ensure you enjoy a comfortable ride, every time."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a cab with us is simple and quick. You can use our website, mobile app, or call our customer service for immediate booking. Our user-friendly platform makes it easy to book your ride at your convenience."
        },
        {
          WhyChooseheading: "Customer Satisfaction Focused",
          WhyChoosedescription: "At AB Ghule Cabs, customer satisfaction is our top priority. We consistently receive positive feedback from our passengers, and we are always looking for ways to improve our service and exceed your expectations."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab near me?',
      answer: 'You can book a cab near your location through our website, mobile app, or by calling our customer service team. It\'s quick and easy to request a ride.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers licensed and experienced?',
      answer: 'Yes, all our drivers are experienced, licensed, and background-checked to ensure your safety and comfort.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles do you offer for booking?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, catering to various travel needs, whether for personal trips, business, or group rides.',
    },
    {
      id: 'FAQ4',
      question: 'How much does it cost to book a cab near me?',
      answer: 'Our prices are competitive and based on your travel distance and time. We offer transparent pricing with no hidden fees, so you\'ll know the fare upfront.',
    },
    {
      id: 'FAQ5',
      question: 'Do you offer 24/7 cab service?',
      answer: 'Yes, we provide cab services 24 hours a day, seven days a week, so you can book a ride anytime you need it.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my ride?',
      answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payment through our app or website for your convenience.',
    },
    {
      id: 'FAQ7',
      question: 'Can I request a specific vehicle for my ride?',
      answer: 'Yes, you can request a specific vehicle based on your preferences, depending on availability. We offer a variety of options to suit different needs.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer airport transfers?',
      answer: 'Yes, we offer convenient airport pick-up and drop-off services. Our drivers will ensure you get to the airport on time or safely reach your destination after your flight.',
    },
    {
      id: 'FAQ9',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can easily cancel or modify your booking through our app, website, or by contacting customer service. We\'re here to assist with any changes to your ride.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other cab services near me?',
      answer: 'AB Ghule Cabs stands out because of our commitment to punctuality, customer satisfaction, affordable pricing, and well-maintained fleet of vehicles. We are dedicated to providing safe, comfortable, and reliable cab services to meet all your transportation needs.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Amit Joshi',
      feedback: 'I always rely on AB Ghule Cabs for my daily commute and occasional trips around the city. The drivers are always punctual, the cars are spotless, and the service is top-notch. I highly recommend them to anyone looking for reliable and affordable cab services in the area!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Rina Mehta',
      feedback: 'I booked a cab with AB Ghule Cabs for a last-minute trip, and I couldn\'t be more pleased. The booking process was fast, and the driver was very professional and courteous. The ride was comfortable, and I reached my destination on time. Definitely my go-to cab service now!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Cabs Services Near Me | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Find the best cabs services near you in Pune with AB Ghule Cabs. Offering affordable local taxi services, 24-hour availability, and reliable booking options across Pune, Pimpri Chinchwad, and nearby areas. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="near me taxi in Pimpri Chinchwad, Cabs services near me in Pune, Taxi near me in Pune, Taxi service near me in Pune, cabs near me in Pune, cab company near me in Pune, taxi cab near me in Viman Nagar, taxi company near me in Kharadi, call taxi near me Kaylani Nagar, cheapest taxi service near me Koregaon Park, Local taxi service near me, Wadgaon Sheri, Taxi cab service near me, Taxi booking near me Hadapsar, 24 hour taxi service near me, Local cab company in Lohegaon airport, Best Taxi Service near me, Book a Taxi online near me, Local cab service near me Chandan Nagar, nearest cab service Kothrud" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Cabs Services Near Me | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Find the best cabs services near you in Pune with AB Ghule Cabs. Offering affordable local taxi services, 24-hour availability, and reliable booking options across Pune, Pimpri Chinchwad, and nearby areas. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/cabs-services-near-me.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/cabs-services-near-me" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Cabs Services Near Me",
        description: "Find the best cabs services near you in Pune with AB Ghule Cabs. Offering affordable local taxi services, 24-hour availability, and reliable booking options across Pune, Pimpri Chinchwad, and nearby areas. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/cabs-services-near-me",
        "logo": "https://abghulecabs.com/images/cabs-services-near-me.jpg",
        "image": "https://abghulecabs.com/images/cabs-services-near-me.jpg",
        "priceRange": "₹300 - ₹3000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/cabs-services-near-me",
          "priceCurrency": "INR",
          "price": "300",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "98"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rahul D"
            },
            "datePublished": "2024-11-05",
            "reviewBody": "Great experience with AB Ghule Cabs! The driver was punctual and friendly, and the ride was smooth and comfortable. Highly recommend their service."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha K"
            },
            "datePublished": "2024-09-30",
            "reviewBody": "Affordable and reliable local cab service. I booked a taxi from Kharadi, and the service was excellent. Will definitely use them again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Cabs Services Near Me",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/cabs-services-near-me"
        },
        "keywords": "near me taxi in Pimpri Chinchwad, Cabs services near me in Pune, Taxi near me in Pune, Taxi service near me in Pune, cabs near me in Pune, cab company near me in Pune, taxi cab near me in Viman Nagar, taxi company near me in Kharadi, call taxi near me Kaylani Nagar, cheapest taxi service near me Koregaon Park, Local taxi service near me, Wadgaon Sheri, Taxi cab service near me, Taxi booking near me Hadapsar, 24 hour taxi service near me, Local cab company in Lohegaon airport, Best Taxi Service near me, Book a Taxi online near me, Local cab service near me Chandan Nagar, nearest cab service Kothrud"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/33.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Cabservicesname;